import React from 'react'

const Gifting = () => {
  return (
    <div>Gifting</div>
  )
}

export default Gifting